/**
 * 子要素<input, select, textarea, 独自コンポーネント>のDisable制御を行うコンポーネント
 *
 * 対応可能パターン：
 * 単一定義：
 * <Enabler>
 *  <input />
 * </Enabler>
 *
 * 複数定義：
 * <Enabler>
 *  <input />
 *  <input />
 *  <input />
 * </Enabler>
 *
 * 対応不可能パターン：
 * <Enabler>
 *  <div>
 *    <input />
 *  </div>
 * </Enabler>
 *
 */
import React, { Component, Children } from 'react';

/**
 * @description 子要素<input, select, textarea, 独自コンポーネント>のDisable制御を行うコンポーネント
 */
export class Enabler extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.targetName = ['FormDropDownSingleSelect']; // コンポーネントの名前を配列で定義する
  }

  /**
   * 制御対象のコンポーネント名かを判別する
   * this.targetNameに対象のコンポーネント名を追加すればOK（element.type.nameで取得できる値であること）
   */
  isControlTarget(name) {
    return this.targetName.indexOf(name) >= 0;
  }

  /**
   * 対象のイレメントにDisable属性を付加し、Cloneしたものを返す
   * ＊Cloneしないと属性の付加ができないため
   */
  disable(e) {
    const property = { disabled: true };
    return React.cloneElement(e, property);
  }

  /**
   * ディゼーブル制御を行う
   * @param {*} element
   */
  controled(element) {
    if (element == null) {
      return;
    }
    switch (element.type) {
      case 'input':
      case 'select':
      case 'textarea':
        if (this.props.enabled) {
          return element;
        } else {
          return this.disable(element);
        }
      default:
        if (
          element.type.name !== undefined &&
          this.isControlTarget(element.type.name)
        ) {
          if (this.props.enabled) {
            return element;
          } else {
            return this.disable(element);
          }
        } else {
          return element;
        }
    }
  }

  render() {
    //var _this = this;
    var props = this.props;
    var results = Children.map(props.children, c => {
      if (
        c.props !== undefined &&
        c.props !== null &&
        c.props.children !== undefined
      ) {
        // 入れ子対応用
        if (Array.isArray(c.props.children)) {
          Children.map(c.props.children, cc => {
            return this.controled(cc);
          });
          // 単独対応用
        } else {
          return this.controled(c);
          //return this.controled(c.props.children); // selectだと取れない
        }
        // 単独対応用
      } else {
        return this.controled(c);
      }
    });
    return results;
  }
}

Enabler.defaultProps = {
  enabled: false,
};



// WEBPACK FOOTER //
// ./src/components/toggle/Enabler.jsx